import React from "react";
import { useTranslation } from "react-i18next";
import { ScoreType } from "@/pages/deals/scoreConfig";
import { scoBadgeSize } from "@/components/ui/KpiScoBadge";
import { DealScoreBadge } from "@/pages/deals/components/DealScoreBadge";
import Spinner from "@/components/ui/spinner";

interface Props {
  isNotCompleted: boolean;
  isGeneral: boolean;
  isStakeholdersApproval: boolean;
  scoreText: string;
  scoreType: ScoreType;
  isLoadingScore: boolean;
  size?: scoBadgeSize;
}

const WorkflowScore: React.FC<Props> = ({
  isNotCompleted,
  isGeneral,
  isStakeholdersApproval,
  scoreText,
  scoreType,
  isLoadingScore = false,
  size = "lg"
}) => {
  const { t } = useTranslation();
  if (isLoadingScore) {
    return <Spinner size="5" />;
  }
  if (isNotCompleted && !isGeneral) {
    return (
      <div className="text-charts-negative text-base">
        {t(
          `deals.dealView.${isStakeholdersApproval ? "stakeholdersApprovalAddScore" : "addScore"}`
        )}
      </div>
    );
  }
  return (
    <DealScoreBadge scoreText={scoreText} scoreType={scoreType} size={size} />
  );
};

export default WorkflowScore;
